import React from 'react';
import { observer } from 'mobx-react';
import './extLink.scss';
import Icon from '@mdi/react';
import { mdiPencil } from '@mdi/js';
import { isValidUrl } from 'cd-eft/utils/stringUtilities';
import linkExternal from '../../../assets/images/link output.svg';

interface Ilink {
  label?: string;
  labelClass?: string;
  id: number | string | undefined;
  adminContent?: boolean;
  onEditClicked?: any;
}

const LinkComponent = (props: Ilink) => {
  const handleEditClicked = (id) => {
    props.onEditClicked(id);
  };

  const internalLinks = [
    'web1-eft.spatialfrontlab.com',
    'web1-eft.efttest.spatialfrontlab.com',
    'eft-aws.sc.egov.usda.gov',
    'aws.cert.sc.egov.usda.gov',
    'eft-dev-aws.dev.sc.egov.usda.gov',
  ];

  const internalLinkTest = internalLinks.some((x) => props.labelClass?.includes(x));
  return (
    <div>
      <div id={`${props.id}`} data-testid="the-linkComp">
        {isValidUrl(props.labelClass) ? (
          <>
            <a
              className={`${props.adminContent ? 'content-comp' : ''}`}
              href={props.labelClass!}
              target="_blank"
              aria-label={`${internalLinkTest ? props.label : props.label + ' external'}`}
            >
              {props.label}
            </a>
            &nbsp;&nbsp;
            {!internalLinkTest && !props.adminContent ? (
              <img src={linkExternal} alt="external link icon" width={12} height={12} />
            ) : null}
          </>
        ) : (
          props.label
        )}
        {/* <a className={`${props.adminContent ? 'content-comp' : ''}`} href={props.labelClass!} target="_blank" aria-label={`${internalLinkTest ? props.label : props.label + ' external'}`}>
                    {props.label}
                </a>&nbsp;&nbsp; */}
        &nbsp;&nbsp;
        {props.adminContent ? (
          <>
            <button className="usa-button--unstyled" onClick={() => handleEditClicked(props.id)}>
              {' '}
              <Icon path={mdiPencil} size={1} /> Edit
            </button>{' '}
          </>
        ) : null}
      </div>
    </div>
  );
};

export const LinkComp = observer(LinkComponent);
